import _ from 'classnames';
import React from 'react';
import styles from "./DataGridCell.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const DataGridCell = /*#__PURE__*/React.memo(({
  children,
  isFirst,
  isLast,
  isLastRow,
  isSticky,
  span,
  isVisible,
  onClick,
  align = 'left',
  isLastButOne,
  hasBody,
  isOverflowing,
  fullyScrolledLeft
}) => {
  return /*#__PURE__*/_jsx("div", {
    onClick: onClick,
    style: {
      gridColumn: span && `span ${span}`
    },
    className: _(styles.dataGridCell, styles[align], {
      [styles.isFirst]: isFirst,
      [styles.isLast]: isLast,
      [styles.isLastRow]: isLastRow,
      [styles.isSticky]: isSticky,
      [styles.isLastButOne]: isLastButOne,
      [styles.hasBody]: hasBody,
      [styles.isOverflowing]: isOverflowing,
      [styles.fullyScrolledLeft]: fullyScrolledLeft
    }),
    children: isVisible !== false && children
  });
});